"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getTheme = void 0;
const color_1 = require("./color");
const predefinedSchemes_1 = require("./color/predefinedSchemes");
const colorSchemes = [predefinedSchemes_1.atom, predefinedSchemes_1.nord, predefinedSchemes_1.dracula, predefinedSchemes_1.material];
const getColorScheme = (name, inverted) => {
    const colors = colorSchemes.find(scheme => scheme.name === name) || colorSchemes[0];
    return inverted ? (0, color_1.getInvertedColorScheme)(colors) : colors;
};
const space = {
    smallest: "0.125rem",
    small: "0.5rem",
    medium: "1rem",
    large: "1.5rem",
    largest: "3rem",
};
const getTheme = (colorScheme, inverted) => ({
    inverted: inverted || false,
    color: getColorScheme(colorScheme, inverted),
    space: space,
});
exports.getTheme = getTheme;
